import { ReportPage } from 'types/pages'

// fixme this really should be dynamic butttttttttt seems hard
export default (reportType?: ReportPage): number | undefined => {
  switch (reportType) {
    case ReportPage.Conversation:
      return 8
    case ReportPage.Automation:
      return 6
    case ReportPage.Call:
      return 4
    case ReportPage.Routing:
      return 1
    case ReportPage.Team:
      return 5
    case ReportPage.Service:
      return 3
  }
}
